
import React from 'react';
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { RsvpStatus } from '../hooks/useRsvpStatus';

interface RsvpActionButtonProps {
  eventId?: string;
  hasResponded: boolean;
  rsvpUpdateAllowed?: boolean;
  checkingRsvpStatus: boolean;
  onUpdateRsvp: () => void;
}

export const RsvpActionButton: React.FC<RsvpActionButtonProps> = ({
  hasResponded,
  rsvpUpdateAllowed,
  checkingRsvpStatus,
  onUpdateRsvp
}) => {
  if (checkingRsvpStatus) {
    return (
      <Button disabled className="mt-2">
        <Clock className="mr-2 h-4 w-4 animate-pulse" />
        Checking...
      </Button>
    );
  }
  
  if (hasResponded && rsvpUpdateAllowed === false) {
    return (
      <p className="text-sm text-amber-600 mt-2 italic">
        RSVP updates are no longer available as the host is finalizing plans
      </p>
    );
  }
  
  return (
    <Button 
      onClick={onUpdateRsvp} 
      variant={hasResponded ? "outline" : "default"}
      className="mt-2"
    >
      {hasResponded ? "Update RSVP" : "Respond to Invitation"}
    </Button>
  );
};
